import { Loader2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface SSOPopupOverlayProps {
  isOpen: boolean;
}

/**
 * Overlay shown while SSO popup is open.
 * Informs the user that authentication is happening in a popup window.
 */
export function SSOPopupOverlay({ isOpen }: SSOPopupOverlayProps) {
  return (
    <Dialog open={isOpen}>
      <DialogContent className="sm:max-w-md" hideCloseButton>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Loader2 className="h-5 w-5 animate-spin" />
            Signing in with SSO
          </DialogTitle>
          <DialogDescription>
            Please complete the sign-in process in the popup window. 
            If you don't see the popup, please check if it was blocked by your browser.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center py-6">
          <div className="text-sm text-muted-foreground text-center">
            <p>A popup window should have opened for you to sign in.</p>
            <p className="mt-2">This window will update automatically once you complete sign-in.</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
